import { getSuperTimeIcon } from "../../utils/getSuperTimeIcon";
import { RECEIVE_NEWSESSION } from "../usuario/usuarioActions";
import { CONCURSOS_SELECIONAR_CONCURSO } from "./concursosActions";

const INITIAL_STATE = { concursos: [], loading: false, listModalidade: [] };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RECEIVE_NEWSESSION:
      // const arrTipoJogo = action.payload.arrTipoJogo;

      // const arrSupertime =
      //   arrTipoJogo &&
      //   arrTipoJogo
      //     .filter(
      //       (tipoJogo) =>
      //         tipoJogo.objTipoJogo.bitConcurso &&
      //         tipoJogo.lstItemApuracao &&
      //         tipoJogo.lstItemApuracao.length > 0
      //     )
      //     .map((concurso) => {
      //       const img = getSuperTimeIcon(concurso.objTipoJogo.vchNome);

      //       return { ...concurso, type: "super-time", vchURLImagem: img };
      //     });

      // const concursos =
      //   arrTipoJogo &&
      //   arrTipoJogo
      //     .filter(
      //       (tipoJogo) =>
      //         tipoJogo.objTipoJogo.bitConcurso &&
      //         (!tipoJogo.lstItemApuracao ||
      //           tipoJogo.lstItemApuracao.length <= 0)
      //     )
      //     .map((concurso) => ({
      //       ...concurso,
      //       supertimeList:
      //         concurso.lstItem && concurso.lstItem.length > 0
      //           ? arrSupertime
      //           : undefined,
      //       type:
      //         concurso.lstItem && concurso.lstItem.length > 0
      //           ? "super-time"
      //           : "concurso",
      //     }));

      // const loterias =
      //   arrTipoJogo &&
      //   arrTipoJogo.filter((tipoJogo) => !tipoJogo.objTipoJogo.bitConcurso);

      // if (loterias && loterias.length > 0) {
      //   const concursoLoteria = {
      //     type: "loteria-popular",
      //     intCodigoRetorno: 0,
      //     objTipoJogo: {
      //       sntTipoJogo: 3,
      //       vchSigla: "W",
      //       vchNome: "Loteria Popular",
      //       listModalidade: loterias,
      //     },
      //   };

      //   concursos.push(concursoLoteria);
      // }

      // if (
      //   window["wweb-session"] &&
      //   window["wweb-session"].objRifas &&
      //   window["wweb-session"].objRifas.arrRifas &&
      //   window["wweb-session"].objRifas.arrRifas.length
      // ) {
      //   const concursoRifa = {
      //     intCodigoRetorno: 0,
      //     type: "rifa",
      //     objTipoJogo: { sntTipoJogo: 999999, vchSigla: "R1", vchNome: "Rifa" },
      //   };
      //   concursos.push(concursoRifa);
      // }

      // const verifiedConcursosPath =
      //   concursos &&
      //   concursos.map((concurso, index) => {
      //     const submenu = ["Apostar"];

      //     if (
      //       ["loteria-popular", "concurso", "rifa", "super-time"].includes(
      //         concurso.type
      //       )
      //     ) {
      //       submenu.push("Como jogar");
      //     }

      //     if (
      //       ["loteria-popular", "concurso", "super-time"].includes(
      //         concurso.type
      //       )
      //     ) {
      //       submenu.push("Cotações");
      //     }

      //     if (
      //       ["loteria-popular", "concurso", "rifa", "super-time"].includes(
      //         concurso.type
      //       )
      //     ) {
      //       submenu.push("Resultados");
      //     }

      //     return {
      //       ...concurso,
      //       submenu,
      //     };
      //   });

      return {
        ...state,
        // concursos: verifiedConcursosPath,
        // listModalidade: loterias,
      };

    case CONCURSOS_SELECIONAR_CONCURSO:
      return {
        ...state,
        concursoAtual: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/concursos/concursosReducer.js